import { SurgicalOrderGuideAuthorizationEnum } from 'domain/usecases/surgical-order-guides/load-surgical-order-guides-authorization'

export const accommodations = [
  { guide_accommodation_type_id: 1, description: 'APARTAMENTO STANDART' },
  { guide_accommodation_type_id: 4, description: 'ENFERMARIA' },
  { guide_accommodation_type_id: 8, description: 'DAY HOSPITAL - APARTAMENTO' },
  { guide_accommodation_type_id: 11, description: 'DAY HOSPITAL - ENFERMARIA' },
  { guide_accommodation_type_id: 15, description: 'AMBULATORIAL' },
  { guide_accommodation_type_id: 20, description: 'APARTAMENTO PEDIATRIA' },
  { guide_accommodation_type_id: 23, description: 'ENFERMARIA PEDIATRIA' }
]

export function getTranslatedAuthorizationStatus(status: string) {
  switch (status) {
    case SurgicalOrderGuideAuthorizationEnum.AUTHORIZED:
      return {
        title: 'Autorizado',
        color: '#4CAF50'
      }

    case SurgicalOrderGuideAuthorizationEnum.PARTIALLY_AUTHORIZED:
      return {
        title: 'Autorizado com divergência',
        color: '#FFC107'
      }

    case SurgicalOrderGuideAuthorizationEnum.PRE_AUTHORIZED:
      return {
        title: 'Pré-autorizado',
        color: '#FFC107'
      }

    case SurgicalOrderGuideAuthorizationEnum.REQUESTED:
      return {
        title: 'Solicitado',
        color: '#FFC107'
      }

    case SurgicalOrderGuideAuthorizationEnum.NEGOTIATION:
      return {
        title: 'Em negociação',
        color: '#FFC107'
      }

    case SurgicalOrderGuideAuthorizationEnum.DENIED:
      return {
        title: 'Negado',
        color: '#D32F2F'
      }

    case SurgicalOrderGuideAuthorizationEnum.FAILURE:
      return {
        title: 'Falha de autorização',
        color: '#D32F2F'
      }

    case SurgicalOrderGuideAuthorizationEnum.PENDENCY:
      return {
        title: 'Possui pendência',
        color: '#FF8D00'
      }
    case SurgicalOrderGuideAuthorizationEnum.ANALYSIS:
      return {
        title: 'Em análise',
        color: '#955DC7'
      }
    case SurgicalOrderGuideAuthorizationEnum.NOT_REQUIRED_AUTHORIZATION:
      return {
        title: 'Não requer autorização',
        color: '#FF8D00'
      }
    case SurgicalOrderGuideAuthorizationEnum.CANCELED:
      return {
        title: 'Cancelado',
        color: '#707683'
      }
    default:
      return {
        title: 'PENDENTE',
        color: '#707683'
      }
  }
}
